module.exports = __webpack_public_path__ + "static/media/404-img3.e9a146d8.gif";